import { render } from "./IQData.vue?vue&type=template&id=168b7aa0"
import script from "./IQData.vue?vue&type=script&lang=js"
export * from "./IQData.vue?vue&type=script&lang=js"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__